import { MATERIALS } from '@/lib/planMaterials';

const BY_KEY = Object.fromEntries(MATERIALS.map((m) => [m.key, m]));
const S = (key, x, y, w, h, extra = {}) => {
  const m = BY_KEY[key];
  return { name: m.name, color: m.color, type: m.type, z: m.z, x, y, w: w ?? m.w, h: h ?? m.h, rot: 0, curve: 0, bow: 0, ...extra };
};

// Starter layouts in metres — dropped in, then adjusted
export const PLAN_TEMPLATES = [
  { id: 'patio', name: 'Small patio garden', desc: '8 × 6 m · patio, lawn, borders', plotW: 8, plotL: 6, ground: 'turf', shapes: [
    S('indian', 0.5, 0.5, 4, 3, { edge: 'cobble' }), S('border', 0, 5.2, 8, 0.8), S('border', 7.2, 0, 0.8, 5.2),
    S('table', 1.4, 0.9, 2.2, 2.2), S('shrub', 6, 1, 1, 1), S('closeboard', 0, 5.9, 8, 0.1),
  ] },
  { id: 'driveway', name: 'Front driveway', desc: '10 × 7 m · block paving, kerbs, beds', plotW: 10, plotL: 7, ground: 'soil', shapes: [
    S('charblock', 0.5, 0, 6, 7, { edge: 'kerb' }), S('steeledge', 6.6, 0, 0.06, 7), S('bark', 7, 0.5, 2.5, 6),
    S('shrub', 7.6, 1.2, 1.2, 1.2), S('shrub', 7.8, 4.2, 1, 1), S('setts', 0.5, 6.4, 6, 0.6),
  ] },
  { id: 'family', name: 'Family garden', desc: '14 × 10 m · patio, lawn, decking, shed', plotW: 14, plotL: 10, ground: 'turf', shapes: [
    S('indian', 0, 0, 6, 3.5, { edge: 'cobble' }), S('compdeck', 9.5, 6, 4.5, 4), S('shed', 0.3, 7.6, 2.5, 2),
    S('border', 0, 3.5, 0.9, 4), S('border', 13.1, 0, 0.9, 6), S('tree', 10, 0.6, 3.5, 3.5), S('table', 1.8, 0.6, 2.2, 2.2),
    S('pebbles', 3.5, 7.6, 2, 2), S('closeboard', 0, 9.9, 14, 0.1),
  ] },
  { id: 'entertain', name: 'Entertaining space', desc: '16 × 11 m · porcelain, kitchen, fire pit, hot tub', plotW: 16, plotL: 11, ground: 'turf', shapes: [
    S('porcelain', 0, 0, 8, 5, { edge: 'kerb' }), S('kitchen', 0.3, 0.3, 4, 0.8), S('firepit', 9.5, 2, 1.6, 1.6), S('pebbles', 9, 1.5, 2.6, 2.6),
    S('hottub', 12.5, 0.5, 2.2, 2.2), S('greydeck', 12, 0, 4, 4), S('hedge', 0, 10.3, 16, 0.7), S('tree', 1, 7, 3, 3), S('pergola', 4.5, 1.2, 3, 3),
  ] },
];
